import React from 'react'

import './checkbox.scss'

export const Checkbox = ({ register, label, error, ...props }) => {
  const wrapperClass = [
    'form-item',
    'form-item-checkbox'
  ]

  if (error) {
    wrapperClass.push('error')
  }

  return (
    <div className={wrapperClass.join(' ')}>
      <label>
        <input type="checkbox" {...props} {...register} />
        {label}
      </label>
      {error && error.message && (
        <span className="validation">
          {error.message}
        </span>
      )}
      {error && error.type == 'required' && (
        <span className="validation">
          Required
        </span>
      )}
    </div>
  )
}

export default Checkbox